import { useFilter } from '@/scopes/checkout/filterableCars/domain/hooks';
import { CarFilterType } from '@/scopes/checkout/filterableCars/domain/types';
import { ListItem, RadioGroup, space, SpaceBetween } from '@sunwebgroup/ui-components';
import * as React from 'react';
import { useIntl } from '@/intl';
import { createCarEvent } from '@/scopes/checkout/domain/analytics';
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks';
import { updateSingleValueFilter } from '@/scopes/checkout/filterableCars/domain/actions';
import {
  FilterItemOption, FilterItemOptionControl,
  FilterLabel, FilterOptionPrice,
  FilterOptionValue,
} from '@/scopes/checkout/components/services/CarRentalFilteringService/FilterableCars/Filters/Filters';
import { toSnakeCase } from '@/helpers/string-helpers';

export function FuelTypeFilter () {
  const { filter, setFilterValue } = useFilter(CarFilterType.FuelType)
  const intl = useIntl();
  const {sendEvent} = useAnalytics();

  const handleFilterValueChange = React.useCallback(
    (value: string) => {
      if (!value) return
      if (!filter) return
      setFilterValue(updateSingleValueFilter({ value })(filter));

      sendEvent(
        createCarEvent({
          result: 'Filter selected',
          type: value,
          description: 'Fuel Type',
          element: 'radiobutton',
          validated: true
        })
      )
    },
    [sendEvent, filter, setFilterValue]
  );

  if (!filter) return null

  const { filterOptions, selectedFilter } = filter

  return (
    <SpaceBetween direction='y' spacing={space('primitives_space_8')}>
      <FilterLabel>{intl.formatMessage({id: `checkout_steps_ancillaries_car_rental_filtering_filters_fuel_type_label`})}</FilterLabel>
      <RadioGroup.Root value={selectedFilter ?? null} onValueChange={handleFilterValueChange}>
        <SpaceBetween direction="y" spacing={space('primitives_space_8')}>
          {filterOptions.map((option) => {
            const { value, name, quantity, startingPrice } = option;

            return (
              <FilterItemOption key={value}>
                <FilterItemOptionControl>
                  <RadioGroup.Item value={value} />
                </FilterItemOptionControl>
                <ListItem.Content>
                  <FilterOptionValue>{intl.formatMessage({id: `checkout_steps_ancillaries_car_rental_filtering_filters_fuel_type_${toSnakeCase(name)}_text`, defaultMessage: name})} {quantity ? `(${quantity})` : ''}</FilterOptionValue>
                </ListItem.Content>
                {startingPrice && (
                  <ListItem.Trailing>
                    <FilterOptionPrice as="span" >
                      {intl.formatMessage({id: `checkout_steps_ancillaries_car_rental_filtering_filters_from_starting_price_text`}, {price: intl.formatCurrency(startingPrice)})}
                    </FilterOptionPrice>
                  </ListItem.Trailing>
                )}
              </FilterItemOption>
            );
          })}
        </SpaceBetween>
      </RadioGroup.Root>
    </SpaceBetween>
  )
}
